import * as React from "react";

import { ChangeObservable } from "common/change-obserable";

export function useChangeObservable<T>(observable: ChangeObservable<T> | undefined): T | undefined {
    const [result, setResult] = React.useState(observable?.current);

    const isFirst = React.useRef(true);
    React.useEffect(() => {
        if (!isFirst.current) {
            setResult(observable?.current);
        }

        isFirst.current = false;

        if (observable === undefined) return undefined;

        const cb = (newValue: T) => {
            setResult(newValue);
        };
        observable.subscribe(cb);
        return () => observable.unsubscribe(cb);
    }, [observable]);
    return result;
}
